import { storesPath, tagsPath, tagPath } from 'app/routes';
import { selectFlyerGib } from 'flux/selectors/flyerGibs.selectors';
import { selectViewerCurrentPages } from 'flux/selectors/viewer.selectors';
import { selectTag } from 'flux/selectors/tags.selectors';
import { selectRouterMatch } from 'flux/selectors/routerMatch.selectors';
import { selectCurrentFlyerId, selectCurrentFlyer } from './flyers.selectors';

const formatPrice = (price) => price?.replace(',', '.').replace(/^\D+/g, '');

const SELECTORS = {
  // flyersPath is handled, but not here
  // flyerPath is handled, but not here
  [storesPath]: () => {
    return {
      section: {
        name: 'stores',
      },
      context: {},
    };
  },
  [tagsPath]: () => {
    return {
      section: {
        name: 'tags',
      },
      context: {},
    };
  },
  [tagPath]: (state, { tagId }) => {
    const tag = selectTag(state, tagId);
    const flyerGib = selectFlyerGib(state, tagId);
    const flyerName = selectCurrentFlyer(state)?.title;

    if (!tag || !flyerGib) return null;

    const price = formatPrice(tag.price);
    const initialPrice = formatPrice(tag.initialPrice);
    const productEcommerceCode = flyerGib.settings.customer_product_id;

    const flyerId = flyerGib.flyer_id;
    const flyerPage = flyerGib.settings?.flyer_page;

    return {
      section: {
        name: 'tag',
      },
      context: {
        tag: {
          title: tag.title,
          price: price ? Number.parseFloat(price) : undefined,
          initialPrice: initialPrice ? Number.parseFloat(initialPrice) : undefined,
          productEcommerceCode,
        },
        flyer: {
          id: flyerId ? +flyerId : undefined,
          pageNumber: flyerPage ? +flyerPage : undefined,
          name: flyerName,
        },
      },
    };
  },
};

export const selectGenericSectionChangePayload = (state) => {
  const routerMatch = selectRouterMatch(state);
  if (!routerMatch) return null;

  const selector = SELECTORS[routerMatch.path];
  if (!selector) {
    return null;
  }

  const result = selector(state, routerMatch.params);
  return result;
};

export const selectFlyerSectionChangePayload = (state) => {
  const flyerId = selectCurrentFlyerId(state);
  if (!flyerId) return null;

  const currentPages = selectViewerCurrentPages(state);
  if (!currentPages || currentPages.length === 0) return null;
  const flyerName = selectCurrentFlyer(state)?.title;

  return {
    section: {
      name: 'flyer',
    },
    context: {
      flyer: {
        id: +flyerId,
        pageNumbers: currentPages.map((page) => +page),
        name: flyerName,
      },
    },
  };
};
